import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import LinkHandler from '../link-handler';

export const UnorderedList = styled.ul`
  display: flex;
  justify-content: center;
  padding-left: 0;
  flex-wrap: wrap;
`;
export const ListItem = styled.li`
  list-style: none;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-evenly;
  align-items: center;
`;
export const SVGIcon = styled(SVG)`
  display: block;
  width: 27px;
  height: 27px;
`;
